import { redirect, createFileRoute } from "@tanstack/react-router";

import { pb } from "@/lib/pocketbase";
import LoginPage from "@/pages/login";

export const Route = createFileRoute("/login")({
  component: LoginPage,
  beforeLoad: () => {
    if (pb.authStore.isValid) {
      // Redirect to admin if already signed in
      throw redirect({ to: "/admin" });
    }
  },
});
